// @ts-nocheck
import { createI18n, I18nOptions, LocaleMessages, VueMessageType } from "vue-i18n";
import en from "./locales/en.json";
import da from "./locales/da.json";
import sv from "./locales/sv.json";
/* https://www.codeandweb.com/babeledit/tutorials/how-to-translate-your-vue-app-with-vue-i18n
 *
 */

// we build a main file with the default locale, the other languages are loaded later
const defaultLocale = import.meta.env.VUE_APP_I18N_LOCALE || "da";

// load our language chunk and set our language after request
// will refresh the views with the new language immediately

export const SUPPORT_LOCALES = ["da", "en", "sv"];

const numberFormats = {
  en: {
    currency: {
      style: "currency",
      currency: "USD"
    },
    percent: {
      style: "percent"
    },
    decimal: {
      style: "decimal"
    }
  },
  da: {
    currency: {
      style: "currency",
      currency: "DKK"
    },
    percent: {
      style: "percent"
    },
    decimal: {
      style: "decimal"
    }
  }
};

const defaultConfig: I18nOptions = {
  locale: "da",
  legacy: true,
  fallbackLocale: defaultLocale,
  messages: { da: da, en: en, sv: sv },
  globalInjection: true,
  numberFormats: numberFormats,
  silentTranslationWarn: process.env.NODE_ENV === "test",
  warnHtmlInMessage: "off"
};

export default createI18n(defaultConfig);

export function setI18nLanguage(i18n, locale) {
  if (i18n.mode === "legacy") {
    i18n.global.locale = locale;
  } else {
    i18n.global.locale.value = locale;
  }
  //  document.querySelector('html').setAttribute('lang', locale)
}

function loadLocaleMessages(): any {
  const locales = require.context("./locales", true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages: LocaleMessages<VueMessageType> = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key).default;
    }
  });
  return messages;
}
/*
export default class i18n {
  static loadLanguage(sprog: string) {
    throw new Error("Method not implemented.");
  }
  static locale: any;
  public static t(key, keys?) {
    const lt = useI18n<{ message: MessageSchema; number: NumberSchema }>({
      useScope: "global"
    });
    return lt.t(key, keys);
  }
  public static n(key, locale?) {
    const lt = useI18n<{ message: MessageSchema; number: NumberSchema }>({
      useScope: "global"
    });
    return lt.n(key, locale);
  }
}
 */
